"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _RadioButton = _interopRequireDefault(require("./RadioButton/RadioButton"));

var _RadioButtons = _interopRequireDefault(require("./RadioButtons.provider"));

var _RadioButtons2 = require("./RadioButtons.styles");

/* eslint-disable jsx-a11y/label-has-associated-control */
var RadioButtons = function RadioButtons(_ref) {
  var className = _ref.className,
      children = _ref.children,
      onChange = _ref.onChange,
      name = _ref.name,
      value = _ref.value,
      type = _ref.type;
  return (0, _jsxRuntime.jsx)(_RadioButtons["default"], {
    onChange: onChange,
    name: name,
    value: value,
    type: type,
    children: (0, _jsxRuntime.jsx)("div", {
      css: _RadioButtons2.styles[type],
      className: (0, _clsx["default"])(className, 'grui inline-flex mw-100'),
      children: children
    })
  });
};

RadioButtons.propTypes = {
  className: _propTypes.string,
  children: _propTypes.node,

  /**
   * The callback function that is triggered when the state changes
   */
  onChange: _propTypes.func,

  /**
   * Radio input name
   */
  name: _propTypes.string,

  /**
   * Selected value
   */
  value: _propTypes.string,
  type: (0, _propTypes.oneOf)(['primary', 'secondary'])
};
RadioButtons.defaultProps = {
  className: undefined,
  children: undefined,
  onChange: function onChange() {},
  name: undefined,
  value: undefined,
  type: 'primary'
};
RadioButtons.Button = _RadioButton["default"];
var _default = RadioButtons;
exports["default"] = _default;
//# sourceMappingURL=RadioButtons.js.map